import React from "react";
import { Divider, Stack, Typography } from "@mui/material";
import { RENTLY_TEXT_COLOR } from "../../../constant/constant";

export const TabHeader = ({ title, breadcrumb, IconComponent }) => {
  return (
    <Stack
      direction="row"
      spacing={2}
      sx={{
        mt: 2,
        ml: 2,
        alignItems: "center",
      }}
    >
      {/* Title */}
      <Typography
        variant="subtitle1"
        fontWeight="bold"
        color={RENTLY_TEXT_COLOR}
      >
        {title}
      </Typography>

      <Divider orientation="vertical" flexItem />

      <Typography
        variant="body2"
        sx={{
          mb: 2,
          color: "#494949ff",
          display: "flex",
          alignSelf: "center",
        }}
      >
        {/* Dynamic Icon */}
        {IconComponent && <IconComponent fontSize="small" color="action" />}

        {/* Display breadcrumb after icon */}
        {` - ${breadcrumb}`}
      </Typography>
    </Stack>
  );
};
